import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

import toast from "react-hot-toast";

import api from "services/api";

import { seasonOptions } from "utils/data";

import moment from "moment";
import { useNavigate } from "react-router-dom";

const AddMoodboardModal = ({
  visible,
  handleClose,
  handleOk,
  collection = {},
  isloading = false,
  handleRefresh = () => {},
}) => {
  const [uploading, setUploading] = useState(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const handleAddMoodboard = async (data) => {
    try {
      setUploading(true);
      let payload = {
        name: data.name,
      };

      //create moodboard
      const newMoodboard = await api.moodboard.create(payload);
      const moodboard_id = newMoodboard?.data?.id;

      if (collection?.id) {
        await api.moodboard.updateCollectionRelation(moodboard_id, {
          collection_id: collection.id,
        });
      }

      setUploading(false);
      handleRefresh();
      handleClose();
      toast.success(`Your Moodboard has been successfully created!`);
      navigate(`/workspace/moodboard?id=${moodboard_id}`);
    } catch (err) {
      setUploading(false);
      toast.error(`Your Moodboard could not be created!`);
      console.log(err);
    }
  };

  return (
    <Dialog
      open={visible}
      onClose={(e, reason) => {
        if (reason != "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">
        Create Moodboard
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form
        onSubmit={handleSubmit(handleOk ? handleOk : handleAddMoodboard)}
        style={{ overflow: "auto" }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
              <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SuiTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                  required
                >
                  Title
                </SuiTypography>
              </SuiBox>
              <SuiInput
                placeholder="Moodboard title"
                required={true}
                {...register("name", {
                  required: "A title is required for moodboard!",
                })}
              />
            </SuiBox>
            <ErrorMessage
              errors={errors}
              name="name"
              render={({ message }) => (
                <SuiTypography
                  variant="text"
                  fontWeight="regular"
                  fontSize="12px"
                  color="error"
                  sx={{ ml: 1 }}
                >
                  {message}
                </SuiTypography>
              )}
            />
            <SuiBox pt={3} px={3} display="flex" justifyContent="end" alignItems="center">
              <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
                <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                  <SuiButton
                    variant="gradient"
                    size="medium"
                    onClick={handleClose}
                    className="mr-2"
                    color="light"
                  >
                    Cancel
                  </SuiButton>
                </SuiBox>
              </SuiBox>
              <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
                <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                  <SuiButton
                    size="medium"
                    variant="gradient"
                    color="dark"
                    type="submit"
                    disabled={isloading}
                  >
                    Save
                  </SuiButton>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </DialogContentText>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default AddMoodboardModal;
